module.exports = __webpack_public_path__ + "img/bj.98c5c3b0.svg";